import { ScalarUUID } from 'hasura';

/** Статус движения награждения */
export interface IClsStatusAwardRequest {
  id: ScalarUUID;
  /** Название */
  name: string;
  /** Код */
  code: string | null;
  /** Дата создания */
  time_create: string;
  /** Признак удаления */
  is_deleted: boolean;
  /** Категория награды */
  id_category_award: ScalarUUID | null;
}

export enum EStatusAwardRequest {
  // STATE
  NEW_STATE = 'NEW_STATE',
  IN_WORK = 'IN_WORK',
  IN_DFO_DIGITAL = 'IN_DFO_DIGITAL',
  PERFORMER_WORK = 'PERFORMER_WORK',
  PERFORMER_WORK_DFO = 'PERFORMER_WORK_DFO',
  PERFORMER_DOCUMENT = 'PERFORMER_DOCUMENT',
  AWAITING_COMMISSION = 'AWAITING_COMMISSION',
  FOR_SIGNATURE = 'FOR_SIGNATURE',
  IN_DFO = 'IN_DFO',
  IN_CAPITAL = 'IN_CAPITAL',
  ARCHIVED_STATE = 'ARCHIVED_STATE',
  DRAFT_STATE = 'DECREE_STATE',

  // REGIONAL
  NEW_REGIONAL = 'NEW_REGIONAL',
  CREATE_LIST = 'CREATE_LIST',
  CREATE_PROTOCOL = 'CREATE_PROTOCOL',
  CREATE_PROJECT = 'CREATE_PROJECT',
  CREATE_DECREE = 'CREATE_DECREE',
  CREATE_AWARD_LIST = 'CREATE_AWARD_LIST',
  PRESENTATION_REGIONAL = 'PRESENTATION_REGIONAL',
  ARCHIVED_REGIONAL = 'ARCHIVED_REGIONAL',
  DRAFT_REGIONAL = 'DECREE_REGIONAL',

  // ENCOURAGEMENT
  NEW_ENCOURAGEMENT = 'NEW_ENCOURAGEMENT',
  PERFORMER_DOCUMENT_ENCOURAGEMENT = 'PERFORMER_DOCUMENT_ENCOURAGEMENT',
  CONSIDERATION_MEETING = 'CONSIDERATION_MEETING',
  CHECK_DOCUMENT = 'CHECK_DOCUMENT',
  PERFORMER_REWORK_ENCOURAGEMENT = 'PERFORMER_REWORK_ENCOURAGEMENT',
  APPROVAL_DEPUTY = 'APPROVAL_DEPUTY',
  CONSIDERATION_GOVERNMENT = 'CONSIDERATION_GOVERNMENT',
  AWAITING_DECISION = 'AWAITING_DECISION',
  SIGNATURE_GOVERNMENT = 'SIGNATURE_GOVERNMENT',
  PREPARATION_DOCUMENT = 'PREPARATION_DOCUMENT',
  PRESENTATION_ENCOURAGEMENT = 'PRESENTATION_ENCOURAGEMENT',
  ARCHIVED_ENCOURAGEMENT = 'ARCHIVED_ENCOURAGEMENT',
  DRAFT_ENCOURAGEMENT = 'DECREE_ENCOURAGEMENT',
}
